function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import React, { useContext } from "react";
import { useUIDSeed } from "react-uid";
import { ImageContext } from "../../../context";
import { transformVideoUrl, twMerge } from "../../../utils";
import { Body, CallToAction, GradientOverlay, Heading, Subheading } from "../../atoms";
import { Section, VideoFrame } from "../../molecules";
import { ArrowRight } from "../../icons";
export function LargeHero(param) {
    var label = param.label, title = param.title, content = param.content, pillars = param.pillars, image = param.image, videoUrl = param.videoUrl, enableLines = param.enableLines, callToActions = param.callToActions, headlinevariant = param.headlinevariant;
    var ctaSeed = useUIDSeed();
    var ImageComponent = useContext(ImageContext).ImageComponent;
    var hVariant = headlinevariant || "h1";
    return /*#__PURE__*/ React.createElement(Section, {
        container: true,
        lines: enableLines ? "light" : false,
        contentBelowLines: true,
        className: "isolate relative"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "absolute top-0 left-0 w-full h-full -z-10 grid grid-cols-1 grid-rows-1"
    }, !!image && /*#__PURE__*/ React.createElement(ImageComponent, _extends({
        className: "col-start-1 row-start-1 w-full h-full object-cover object-center"
    }, image)), !!videoUrl && /*#__PURE__*/ React.createElement(VideoFrame, {
        title: title,
        url: videoUrl,
        className: "col-start-1 row-start-1 w-full h-full",
        transform: transformVideoUrl
    }), /*#__PURE__*/ React.createElement(GradientOverlay, {
        className: "col-start-1 row-start-1 w-full h-full z-10"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "relative text-fg-inverted pt-10 md:pt-12"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-auto gap-5"
    }, !!label && /*#__PURE__*/ React.createElement(Subheading, {
        className: "text-fg-inverted/40"
    }, label), /*#__PURE__*/ React.createElement(Heading, {
        as: "h1",
        variant: hVariant,
        className: "leading-tight"
    }, title)), !!content && /*#__PURE__*/ React.createElement("div", {
        className: twMerge("mt-6 grid grid-cols-1 gap-6 md:grid-cols-2", (!(pillars === null || pillars === void 0 ? void 0 : pillars.length) || !!(callToActions === null || callToActions === void 0 ? void 0 : callToActions.length)) && "mt-9 md:mt-11")
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Body, {
        className: "opacity-60 leading-extra"
    }, content)), !!(callToActions === null || callToActions === void 0 ? void 0 : callToActions.length) && /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: twMerge("flex items-center flex-wrap -m-4 md:justify-end")
    }, callToActions.map(function(action) {
        return /*#__PURE__*/ React.createElement(CallToAction, _extends({}, action, {
            key: ctaSeed(action),
            subtle: true,
            className: "m-4",
            icon: /*#__PURE__*/ React.createElement(ArrowRight, {
                className: "text-fg-inverted"
            }),
            linkVariant: "big"
        }));
    })))), !!(pillars === null || pillars === void 0 ? void 0 : pillars.length) && /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 gap-7 mt-10 md:mt-12 md:grid-cols-3"
    }, pillars.map(function(pillar) {
        return /*#__PURE__*/ React.createElement("div", {
            key: pillar.title
        }, /*#__PURE__*/ React.createElement(Heading, {
            as: "h3",
            variant: "h4"
        }, pillar.title), /*#__PURE__*/ React.createElement("div", {
            className: "mt-2 md:mt-7"
        }, /*#__PURE__*/ React.createElement(Body, {
            className: "opacity-60 leading-extra"
        }, pillar.description)));
    }))));
}

//# sourceMappingURL=LargeHero.js.map